module.exports = __webpack_public_path__ + "static/media/Team 6 - Ecostability.1986719c.png";